import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import Login from 'app/modules/login/login';
import Register from 'app/modules/account/register/register';
import Account from 'app/modules/account';
import Activate from 'app/modules/account/activate/activate';
import PasswordResetInit from 'app/modules/account/password-reset/init/password-reset-init';
import PasswordResetFinish from 'app/modules/account/password-reset/finish/password-reset-finish';
import Logout from 'app/modules/login/logout';
import Home from 'app/modules/home/home';
import Admin from 'app/modules/administration';
import Entities from 'app/entities';
import PrivateRoute from 'app/shared/auth/private-route';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import { AUTHORITIES } from 'app/config/constants';
import { HomeComp } from 'app/modules/home-comp/home-comp';
import Modules from 'app/modules';

const sectionKey = (pathname: string) => {
  const parts = pathname.split('/').filter(part => part !== '');
  return parts[0] === 'home' ? 'home' : parts.slice(0, 2).join('/');
};

const renderRoutes = ({ location }) => (
  <div className="view-routes route-enter" key={sectionKey(location.pathname)}>
    <Switch location={location}>
      <ErrorBoundaryRoute path="/login" component={Login} />
      <ErrorBoundaryRoute path="/logout" component={Logout} />
      <ErrorBoundaryRoute path="/register" component={Register} />
      <ErrorBoundaryRoute path="/activate/:key?" component={Activate} />
      <ErrorBoundaryRoute path="/reset/request" component={PasswordResetInit} />
      <ErrorBoundaryRoute path="/reset/finish/:key?" component={PasswordResetFinish} />
      <PrivateRoute path="/admin" component={Admin} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute path="/account" component={Account} hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.USER]} />
      <PrivateRoute path="/entity" component={Entities} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      {/* <PrivateRoute path="/home" component={Home} hasAnyAuthorities={[AUTHORITIES.USER]} /> */}
      <PrivateRoute path="/" component={Modules} hasAnyAuthorities={[AUTHORITIES.USER]} />
    </Switch>
  </div>
);

const Routes = () => <Route render={renderRoutes} />;

export default Routes;
